<template>
  <div>
    <b-sidebar
      id="sidebar-customer"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-edit-product-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div v-if="isLoading">
          <OtherLoading />
        </div>
        <div class="py-3" v-else>
          <label class="ml-2">ข้อมูลสินค้า</label>
          <div class="mt-3 p-2 detail-panel">
            <div class="d-flex justify-content-between">
              <label>{{ detail.product_id }}</label>
              <label>{{ detail.price | numeral("0,0.00") }}</label>
            </div>
            <p class="mt-2">{{ detail.product_name }}</p>
            <div class="mt-2 d-flex justify-content-between">
              <div class="d-flex">
                <font-awesome-icon
                  icon="plus-circle"
                  title="up-btn"
                  class="icon-up-down"
                  @click="upProductQuantity()"
                />
                <InputText
                  textFloat=""
                  v-model="detail.quantity"
                  class="w-25"
                  placeholder="0"
                  type="number"
                />
                <font-awesome-icon
                  icon="minus-circle"
                  title="down-btn"
                  class="icon-up-down"
                  @click="downProductQuantity()"
                />
              </div>
              <InputText
                textFloat=""
                v-model="detail.price"
                class="w-50"
                placeholder="0"
                type="number"
              />
            </div>
          </div>
          <div class="mt-4">
            <b-row class="mx-0 text-sub">
              <b-col
                class="px-0 py-1 tab-product text-center pointer"
                :style="
                  tabCurrent == 1
                    ? `color: ${$store.state.colorPrimary};${$store.state.backgroundSecondary};border-bottom: 5px solid ${$store.state.colorPrimary};`
                    : ''
                "
                @click="selectTab(1)"
              >
                <p class="text-nowrap">Promotion</p>
                <p>โปรโมชัน</p>
                <p>(3)</p>
              </b-col>
              <b-col
                class="px-0 py-1 tab-product text-center pointer"
                :style="
                  tabCurrent == 2
                    ? `color: ${$store.state.colorPrimary};${$store.state.backgroundSecondary};border-bottom: 5px solid ${$store.state.colorPrimary};`
                    : ''
                "
                @click="selectTab(2)"
              >
                <p class="text-nowrap">Item Discount</p>
                <p>ส่วนลดรายการ</p>
                <p>(4)</p>
              </b-col>
              <b-col
                class="px-0 py-1 tab-product text-center pointer"
                :style="
                  tabCurrent == 3
                    ? `color: ${$store.state.colorPrimary};${$store.state.backgroundSecondary};border-bottom: 5px solid ${$store.state.colorPrimary};`
                    : ''
                "
                @click="selectTab(3)"
              >
                <p class="text-nowrap">Header Discount</p>
                <p>ส่วนลดท้ายบิล</p>
                <p>(2)</p>
              </b-col>
            </b-row>
            <b-row
              class="mx-0 py-2 border-bottom"
              v-for="(d, index) in tabCurrent == 1
                ? promotion
                : tabCurrent == 2
                ? itemDiscount
                : headerDiscountOption"
              :key="index"
            >
              <b-col
                cols="2"
                class="d-flex justify-content-center align-items-center"
              >
                <b-form-checkbox
                  v-if="tabCurrent == 1"
                  v-model="promotionSelect"
                  :value="d.id"
                ></b-form-checkbox>
                <b-form-checkbox
                  v-if="tabCurrent == 2"
                  v-model="itemDiscountSelect"
                  :value="d.id"
                ></b-form-checkbox>
                <b-form-checkbox
                  v-if="tabCurrent == 3"
                  v-model="headerDiscountSelect"
                  :value="d.id"
                ></b-form-checkbox>
              </b-col>
              <b-col cols="6" class="px-2">
                <p>
                  <strong>{{ d.id }}</strong>
                </p>
                <p class="text-sub">{{ d.name }}</p>
                <p class="text-sub">
                <u @click="openModalEdit(index)">ปรับส่วนลด</u>
              </p>
              </b-col>
              <b-col cols="4" class="px-2"
                ><p class="float-right text-nowrap">
                  {{ d.promotion_value | numeral("0,0.00") }}
                  {{ d.promotion_discount_type_id == 1 ? "%" : "บาท" }}
                </p></b-col
              >
            </b-row>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="text-center">
          <div class="mb-4 w-100">
            <b-button
              class="radius-btn text-white w-75"
              :style="$store.state.backgroundSecondary"
              @click="submitEditProduct"
              ><span>บันทึก</span></b-button
            >
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText";
export default {
  name: "SlideEditProduct",
  components: { OtherLoading, InputText },
  props: {
    user: {
      type: Object,
      isRequired: true,
    },
    headerDiscountSelectMain: {
      type: Array,
      isRequired: true,
    },
    headerDiscountOption: {
      type: Array,
      isRequired: true,
    },
  },
  data() {
    return {
      showSlide: false,
      index: 0,
      detail: {},
      promotion: [],
      itemDiscount: [],
      promotionSelect: "",
      itemDiscountSelect: "",
      headerDiscountSelect: [],
      headerDiscountSelectList: [],
      tabCurrent: 0,
      isLoading: false,
    };
  },
  watch: {
    headerDiscountSelect: {
      handler(val) {
        this.headerDiscountSelectList = [];
        this.headerDiscountSelect.forEach((d, index) => {
          this.headerDiscountOption.forEach((h, i) => {
            if (d == h.id) {
              this.headerDiscountSelectList.push({
                id: h.id,
                custom_header_discount: h.promotion_value,
              });
            }
          });
        });
      },
    },
  },
  methods: {
    show(form, index) {
      this.tabCurrent = 1;
      this.detail = JSON.parse(form).product[index];
      this.promotionSelect = JSON.parse(form).product[index].sap_discount.id
        ? JSON.parse(form).product[index].sap_discount.id
        : "";
        
      this.itemDiscountSelect = JSON.parse(form).product[index].item_discount.id
        ? JSON.parse(form).product[index].item_discount.id
        : "";
      this.headerDiscountSelect = this.headerDiscountSelectMain;
      this.index = index;
      this.getDiscount(1);
      this.getDiscount(2);
      this.showSlide = true;
    },
    hide() {
      this.showSlide = false;
      this.promotionSelect = "";
      this.itemDiscountSelect = "";
      this.headerDiscountSelect = [];
      this.headerDiscountSelectList = [];
    },
    getDiscount(type) {
      this.isLoading = true;
      this.axios
        .get(
          `${this.$baseUrl}/promotion/get_list/${type}/${this.detail.id}/${
            this.user.user_guid
          }/${moment().format("YYYY-MM-DD HH:mm:ss")}/${this.$cookies.get(
            "branch_id"
          )}`
        )
        .then((data) => {
          if (data.result == 1) {
            if (type == 1) {
              this.promotion = data.detail;
            } else {
              this.itemDiscount = data.detail;
            }
          }
          this.isLoading = false;
        });
    },
    upProductQuantity(index) {
      this.detail.quantity += 1;
    },
    downProductQuantity(index) {
      if (this.detail.quantity > 1) {
        this.detail.quantity -= 1;
      }
    },
    selectTab(tab) {
      this.tabCurrent = tab;
    },
    async openModalEdit(index) {
      this.$emit("onOpenEditHeaderDiscountModal", index);
    },
    resetCalculateList() {
      this.headerDiscountSelect.push("update");
      this.headerDiscountSelect.pop();
    },
    submitEditProduct() {
      let detail = {
        product: this.detail,
        promotion: { id: this.promotionSelect, option: this.promotion },
        itemDiscount: this.itemDiscountSelect,
        headerDiscount: {
          detail: this.headerDiscountSelectList,
          id: this.headerDiscountSelect,
        },
      };
      this.$emit("onEditProduct", detail, this.index);
      this.hide();
    },
  },
};
</script>

<style scoped>
.icon-up-down {
  margin: 12px 10px 0px 10px;
}
.tab-product {
  color: #fff;
  background-color: #dedede;
  border-bottom: 5px solid #dedede;
}
</style>
